/*
 * Manages the display and behavior of page and field level help text.
*/
rs.module("controls/help/helphost",

    [
        "ui/framework/userstate-manager",
        "layouts/site-shell"
    ],

    function (userStateManager, siteShell) {

        var _visible = false;
        var _cssClasses;
        var _dataAttributes;
        var _userStateKey;
        var _backendUrl;

        // Selectors used internally but mean nothing outside of this file.
        const privateSelectors = {
            indicator : "helpicon"
        }

        // Value defined in HelpHostUtility.cs
        const helpPresenceHeader = "Help-Presence"

        const dataInit = 'data-help-init';
        const dataHelp = 'data-help';

        //
        // Initialize
        //
        function initialize(cssClasses, dataAttributes, backendUrl, userStateKey, visible) {
            _cssClasses = cssClasses;
            _dataAttributes = dataAttributes;
            _userStateKey = userStateKey;
            _backendUrl = backendUrl;
            
            _visible = visible;
            _updateVisibility();

            // listen for the content area to be resized
            siteShell.contentAreaResized(function () {

                // update the positioning of all tooltips
                $.js(privateSelectors.indicator, { required: false, multiple: true }).each(function () {

                    if (!$(this).is("a")) {
                        $(this).tooltip('update');
                    }
                });
            });

            // We need to make sure tooltips are initialized for any incoming ajax content
            $(document).ajaxSuccess(function (event, jqXHR) {
                if (jqXHR.getResponseHeader(helpPresenceHeader)) {
                    setTimeout(initializeTooltips);
                }
            });
        }

        // Appends a hyperlink for More Information which points to the helpTopic url
        function _appendMoreLink(helpContent, helpTopicHref) {
            var moreDiv = $("<div />")
                .addClass(_cssClasses.moreInfo);

            $("<a />")
                .attr("href", helpTopicHref)
                .attr("target", "_blank")
                .text("More information").appendTo(moreDiv);

            return helpContent + moreDiv[0].outerHTML;
        }

        // Initializes tooltips 
        function initializeTooltips() {

            // Initialize the tooltips for any uninitialized elements which have help attached
            $(`[${dataHelp}="true"]`).not(`[${dataInit}="true"]`).each(function () {

                // Gather all of the configuration residing in data-* attributes.
                var tipContent = $(this).data(_dataAttributes.helpContent);
                var tipContentId = $(this).data(_dataAttributes.helpContentId);
                var helpTopicHref = $(this).data(_dataAttributes.linkedTopicHref);
                var ajaxContent = false;
                var anchor = false;

                if (tipContentId) {
                    ajaxContent = true;
                }
                else if (helpTopicHref) {

                    // if there is content, an external link is included as a hyperlink inside the popup
                    if (tipContent) {
                        // add the More Information link
                        tipContent = _appendMoreLink(tipContent, helpTopicHref);
                    }
                    else {
                        // without content, the entire icon needs to be a hyperlink and the popup is avoided completely
                        anchor = true;
                    }
                }

                // create the visual indicator which serves as the tooltip host
                var indicator = $(`<${anchor ? "a" : "span"} />`)
                    .attr("data-js", privateSelectors.indicator)
                    .attr("tabindex", "0") 
                    .addClass(_cssClasses.indicator)
                    .addClass(_cssClasses.helpIcon);

                // if this is going to be an anchor, complete its attributes
                if (anchor) {
                    indicator
                        .attr("href", helpTopicHref)
                        .attr("title", "Click for more information.")
                        .attr("target", "_blank");
                }

                // if help isn't visible/active, hide the indicator
                if (!_visible) {
                    indicator.addClass(_cssClasses.hidden);
                }

                // if the indicator will behave as a popup, as opposed to just a link to content, setup options for bootstrap's tooltip plugin
                if (!anchor) {

                    $(indicator).on('click enterpressed', function (e) {
                        e.preventDefault();
                    });

                    var tooltipOptions =
                    {
                        html: true,
                        // Would also like to add the "click" trigger, but this can result in a tooltip appearing ontop of the site's popout menu.  Looks bad.  
                        // Due to the menu structure, and stacking contexts, no combination of tooltipOptions.container and tooltip/menu z-index tweaking produces
                        // behavior where the tooltips are above the menu dock but beneath the menu popout.
                        trigger: "hover focus",
                        delay: { "show": 100, "hide": 500 },
                        placement: "auto"
                    };

                    // Ajax loaded content requires a bit of setup 
                    if (ajaxContent) {

                        // Create an element which will serve as both the tooltip's content and a placeholder for the dynamically 
                        // loaded content when it is available.
                        tipContent = $("<span />")
                            .addClass(_cssClasses.loadingIcon)
                            .addClass(_cssClasses.loadingSpinner)
                            .addClass("icon");

                        // The tooltip plugin can use an element, a string, or a function.  A function is expected to be syncronous so 
                        // we'll just use an element whose content we replace later.
                        tooltipOptions.title = tipContent[0];

                        // Listen for the tooltip to be activated so we can request its content.
                        indicator.on("show.bs.tooltip", function (e) {

                            // Make the call to get the content
                            $.ajax(_backendUrl,
                                {
                                    data: {
                                        contentId: tipContentId
                                    }
                                }).done(function (result) {

                                    // Replace the placeholder element with the returned content.
                                    if (helpTopicHref) {
                                        result = _appendMoreLink(result, helpTopicHref);
                                    }
                                    tipContent.replaceWith(result);
                                });
                        });
                    }
                    else {
                        // Static text content just goes into the title attribute, where it's picked up by the tooltip plugin
                        indicator.attr("title", tipContent);
                    }

                    // Initialize the bootstrap tooltip.
                    indicator.tooltip(tooltipOptions);
                }

                // Add the indicator to the DOM now that it's all ready.
                $(this).append(indicator);

                // Remember that it has been initialized
                $(this).attr(dataInit, "true");
            });
        }

        // Show or hide the help indicators
        function _updateVisibility() {
            if (_visible) {
                // Initializing tooltips on-demand so we aren't doing work that most of the time will be unused
                initializeTooltips();

                // Show all help indicators
                $.js(privateSelectors.indicator, { required: false, multiple: true }).each(function () {
                    $(this).removeClass(_cssClasses.hidden);
                });
            }
            else {
                // Hide
                $.js(privateSelectors.indicator, { required: false, multiple: true }).each(function () {
                    $(this).addClass(_cssClasses.hidden);

                    if (!$(this).is("a")) {
                        $(this).tooltip("hide");
                    }
                });
            }
        }

        // Gets the visibility of help tips
        function getVisible() {
            return _visible;
        }

        // Sets the visibility of help tips
        function setVisible(visible) {
            _visible = visible;

            // Save the state
            userStateManager.persist(_userStateKey, _visible);

            // Update UI with the new state
            _updateVisibility();
        }

        // Updates the help text of a given element
        function updateHelpText(element, helpText) {

            element.empty();
            element.attr(dataHelp, true);
            element.removeAttr(dataInit);
            element.data(_dataAttributes.helpContent, helpText);

            initializeTooltips();
        }

        // Exported public API
        var exports = {
            initialize,
            updateHelpText
        };

        Object.defineProperty(exports, "visible",
            {
                get: getVisible,
                set: setVisible
            });

        return exports;
    }
);